import { Col, Form, Row } from "react-bootstrap";

const ThirdStepMobile = ({thirdStep, updateMultipleValues}) => {

    const handleChangeRadio = (e) => {
        const values = {...thirdStep};
        values[e.target.id] = parseInt(e.target.value);
        updateMultipleValues({thirdStep: values});
    }
    return (
      <>
        <div className="d-flex flex-column  position-relative" onChange={(e) => handleChangeRadio(e)}>
        
            <h1 className="register-text" style={{fontSize: 24, marginBottom: 15}}>Learning methods, activities and set-up of the course</h1>
            {/* <div className="d-flex  align-items-end"> */}
            <Row style={{background: "rgba(217, 217, 217, 1)", color: "black", marginRight: 0, marginLeft: 0}}>
                <Col xs={3}><div className="form-label-mobile" style={{textAlign: "center"}}>Strongly disagree</div>
                </Col>
                <Col xs={2}><div className="form-label-mobile" style={{textAlign: "center"}}>Disagree</div>
                </Col>
                <Col xs={2}><div className="form-label-mobile" style={{textAlign: "center"}}>Neutral</div>
                </Col>
                <Col xs={2}><div className="form-label-mobile" style={{textAlign: "center"}}>Agree</div>
                </Col>
                <Col xs={3}><div className="form-label-mobile" style={{textAlign: "center"}}>Strongly agree</div>
                </Col>
            </Row>
            <Form>
                <Form.Group>
                    <Row style={{marginTop: 20, marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`course_relevant_lectures`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_relevant_lectures === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`course_relevant_lectures`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_relevant_lectures === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`course_relevant_lectures`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_relevant_lectures === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`course_relevant_lectures`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_relevant_lectures === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`course_relevant_lectures`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_relevant_lectures === 5}
                                />
                        </Col>
                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}}>The lectures of the course were adding to my understanding of the topic(s) *</div>
                        </Col>

                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`course_motivational_activities`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_motivational_activities === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`course_motivational_activities`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_motivational_activities === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`course_motivational_activities`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_motivational_activities === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`course_motivational_activities`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_motivational_activities === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`course_motivational_activities`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_motivational_activities === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}} >The activities in the course motivated me *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`course_future_employment`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_future_employment === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`course_future_employment`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_future_employment === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`course_future_employment`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_future_employment === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`course_future_employment`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_future_employment === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`course_future_employment`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_future_employment === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}} >The activities in the course prepared me for my future employment *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`course_societal_reflexion`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_societal_reflexion === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`course_societal_reflexion`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_societal_reflexion === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`course_societal_reflexion`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_societal_reflexion === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`course_societal_reflexion`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_societal_reflexion === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`course_societal_reflexion`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_societal_reflexion === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}} >The activities in the course helped me reflect on current societal challenges *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`course_materials`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_materials === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`course_materials`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_materials === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`course_materials`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_materials === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`course_materials`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_materials === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`course_materials`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_materials === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}} >I understand how I can apply the course materials in a practical setting *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`course_social_interaction`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_social_interaction === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`course_social_interaction`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_social_interaction === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`course_social_interaction`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_social_interaction === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`course_social_interaction`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_social_interaction === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`course_social_interaction`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_social_interaction === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}} >The number of social interactions with students in the course was sufficient *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`course_study_load`}
                                    name="group7"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_study_load === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`course_study_load`}
                                    name="group7"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_study_load === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`course_study_load`}
                                    name="group7"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_study_load === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`course_study_load`}
                                    name="group7"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_study_load === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`course_study_load`}
                                    name="group7"
                                    style={{fontSize: 16}}
                                    checked={thirdStep?.course_study_load === 5}
                                />
                        </Col>

                        <Col  xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}} >The study load was evenly distributed throughout the course *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
      </div>
      </>
    );
  };
  
  export default ThirdStepMobile;
  